import blogRecordsJson from './blogs.json';

export type BlogRecord = {
  id: number;
  coverImage: string;
  title: string;
  description: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  category: string;
  alt: string;
};

const blogRecords = blogRecordsJson as BlogRecord[];

function formatDisplayDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Plain text for search (strip HTML). */
export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export type BlogCard = {
  id: number;
  title: string;
  image: string;
  alt: string;
  date: string;
  category: string;
  searchBlob: string;
};

export function getBlogCards(): BlogCard[] {
  return [...blogRecords]
    .filter((b) => b.status === 'active')
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .map((b) => ({
      id: b.id,
      title: b.title,
      image: b.coverImage,
      alt: b.alt,
      date: formatDisplayDate(b.createdAt),
      category: b.category,
      searchBlob: `${b.title} ${b.category} ${stripHtml(b.description)}`.toLowerCase(),
    }));
}

export type BlogDetail = {
  id: number;
  title: string;
  image: string;
  alt: string;
  date: string;
  category: string;
  descriptionHtml: string;
  updatedLabel: string;
};

export function getBlogById(id: number): BlogDetail | undefined {
  const b = blogRecords.find((x) => x.id === id && x.status === 'active');
  if (!b) return undefined;
  return {
    id: b.id,
    title: b.title,
    image: b.coverImage,
    alt: b.alt,
    date: formatDisplayDate(b.createdAt),
    category: b.category,
    descriptionHtml: b.description,
    updatedLabel: formatDisplayDate(b.updatedAt),
  };
}

export function getAllBlogStaticParams(): { id: string }[] {
  return blogRecords.filter((b) => b.status === 'active').map((b) => ({ id: String(b.id) }));
}
